import * as React from 'react';
import ReactDom from 'react-dom';
import { emporiModule } from '@empori/util';
import { EmployeeCarousel } from './components/employeeCarousel';
import { Timeline } from './components/timeline';
emporiModule('progritsLoaded', {
    progrits: {
        InitEmployeeCarousel: function (element, employeeData) {
            ReactDom.render(React.createElement(EmployeeCarousel, { employees: employeeData }), document.querySelector(element));
        },
        InitTimeline: function (element, timelineData) {
            ReactDom.render(React.createElement(Timeline, { yearStamps: timelineData }), document.querySelector(element));
        }
    }
});
